import React from 'react'
import { Controller, Control, UseControllerProps } from 'react-hook-form'
import { Upload, UploadProps } from '@surecompanies/core_components'
import { Stack, TextColors, Typography } from '@sureco/design-system'
import { InboxOutlined } from '@ant-design/icons'

type RHFDraggerProps = Omit<UploadProps, 'name'> & {
  name: string
  control: Control<any, object> // unable to make it work using generics yet Control<T>
  rules?: UseControllerProps['rules']
  hint?: React.ReactNode
}
export default function RHFDragger({
  name,
  control,
  rules,
  children,
  hint,
  ...rest
}: RHFDraggerProps) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => {
        return (
          <Stack space={2}>
            <Upload.Dragger
              name={field.name}
              {...rest}
              style={{
                borderColor: fieldState.error ? TextColors.error : undefined,
              }}
            >
              <Stack>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <Typography size={14} color={TextColors.primary}>
                  Click or drag file to this area to upload
                </Typography>
                {hint}
              </Stack>
            </Upload.Dragger>
            {fieldState.error && (
              <Typography color={TextColors.error}>
                {fieldState.error.message}
              </Typography>
            )}
          </Stack>
        )
      }}
    />
  )
}
